import { useEffect, useMemo, useState } from "react";
import { newsList, newsCategories } from "@/mocks/news";
import NewsListItem from "@/components/base/NewsListItem";
import Pagination from "@/components/base/Pagination";
import Breadcrumb from "@/components/base/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";

const PAGE_SIZE = 5;

export default function News() {
  const [category, setCategory] = useState("全部");
  const [page, setPage] = useState(1);

  useEffect(() => {
    document.title = "影视资讯 - 泡泡影视";
  }, []);

  const filtered = useMemo(
    () => (category === "全部" ? newsList : newsList.filter((n) => n.category === category)),
    [category]
  );

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const pageItems = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="w-full px-4 md:px-8 pt-6">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <div className="mt-5 rounded-xl bg-primary-950 px-6 py-8 md:px-10 md:py-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
          影视资讯
        </h1>
        <p className="mt-2 text-sm md:text-base text-background-300 max-w-2xl leading-relaxed">
          汇集影视行业动态、深度影评、票房解读与剧集情报，带你读懂银幕背后的故事。
        </p>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {["全部", ...newsCategories].map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => {
              setCategory(tab);
              setPage(1);
            }}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              category === tab
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-6 flex flex-col gap-4">
        {pageItems.length > 0 ? (
          pageItems.map((article) => <NewsListItem key={article.id} article={article} />)
        ) : (
          <EmptyState
            title="暂无相关资讯"
            description="这个栏目暂时还没有内容，换个栏目看看吧。"
            actionLabel="查看全部资讯"
            onAction={() => {
              setCategory("全部");
              setPage(1);
            }}
          />
        )}
      </div>

      {pageItems.length > 0 && (
        <div className="mt-10">
          <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
        </div>
      )}
    </div>
  );
}